import { render, staticRenderFns } from "./addTakeReduceBaof.vue?vue&type=template&id=460513a3"
import script from "./addTakeReduceBaof.vue?vue&type=script&lang=js"
export * from "./addTakeReduceBaof.vue?vue&type=script&lang=js"
import style0 from "./addTakeReduceBaof.vue?vue&type=style&index=0&id=460513a3&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports